import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { getByDmService, updateDmService } from '../../../services/Api';
// import appConfig from '../../../config/app-config';

// const { IMAGE_PATH } = appConfig;

class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      confirmPassword: '',
      user: JSON.parse(localStorage.getItem('user')) || { nivel: {} },
    };
  }

  componentWillMount = async () => {
    try {
      const { user } = this.state;
      const data = await getByDmService('/Usuario', user.id);
      this.setState({
        ...data,
        // cadastradoEm: `Cadastrado em: ${  data.dataCadastro}`,
        // backgroundImage: IMAGE_PATH + data.foto,
      });
    } catch (e) {
      toast.error('Ocorreu um erro ao carregar os dados');
    }
  };

  handleUploadFile = files => {
    const file = files[0];
    // this.setState({ nomeArquivo: file.name });
    const reader = new FileReader();
    const self = this;
    reader.onloadend = () => {
      self.setState({
        backgroundImage: reader.result,
        fotoBase64: reader.result.replace(/data:image\/(png|jpeg);base64,/g, ''),
      });
    };
    reader.readAsDataURL(file);
  };

  removeFile = () => {
    // this.setState({ backgroundImage: null, fotoBase64: null, nomeArquivo: null });
  };

  onChangePassword = event => {
    const { password } = this.state;
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.value !== password)
      event.target.setCustomValidity('Senha e Confirmar senha precisam ser iguais.');
    else event.target.setCustomValidity('');
  };

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onsubmit = e => {
    e.preventDefault();
    if (e.target.checkValidity()) this.save();
  };

  save = () => {
    const { password, confirmPassword, user } = this.state;
    const { history } = this.props;
    const formData = {
      password,
      confirmPassword,
    };
    // this.setState({ isSaving: true });
    const { id } = user;
    updateDmService('/Usuario/AlterarSenha', id, formData)
      .then(() => {
        // this.setState({ isSaving: false });
        toast.success('Dados atualizados com sucesso');
        history.push('informacoes');
      })
      .catch(err => {
        if (typeof err.error.response.data.modelState !== 'undefined') {
          let error = 'Ocorreu o seguinte erro: ';

          const erros = err.error.response.data.modelState;
          for (const p in erros) {
            let name = p.replace('model.', '');
            name = name[0].toUpperCase() + name.slice(1);
            error += `${name}: ${erros[p]}; `;
          }
          toast.error(error);
        } else {
          toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
        }
        // this.setState({ isSaving: false });
      });
  };

  render() {
    const { password, confirmPassword } = this.state;
    return (
      <form id="form" onSubmit={this.onsubmit}>
        <div className="box-padd">
          <div className="bx--row">
            <div className="bx--col-xs-6 bx--col-md-6 v-md-margin">
              <label className="bx--label">Nova Senha</label>
              <input
                type="password"
                className="bx--text-input"
                required
                placeholder="Nova Senha"
                name="password"
                value={password}
                onChange={this.onChangeText}
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-xs-6 bx--col-md-6 v-md-margin">
              <label className="bx--label">Repetir a Nova Senha</label>
              <input
                type="password"
                className="bx--text-input"
                required
                placeholder="Repetir a Nova Senha"
                name="confirmPassword"
                value={confirmPassword}
                onChange={this.onChangePassword}
              />
            </div>
          </div>

          <div className="mg-top-40">
            <div className="bx--row">
              <div className="bx--col-xs-2">
                <br />
                <button className="bx--btn btn-primary-color" type="submit">
                  Salvar Alterações
                </button>
              </div>
              <div className="bx--col-xs-2">
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/screens/client/profile/ChangePassword.js